module.exports = __webpack_public_path__ + "static/media/card_insurance_car.833b6dcd.jpg";